import { Component } from '@theme/component';

/**
 * Handles unit toggling (cm/in) for measurement tables.
 *
 * @extends {Component}
 */
class MeasurementTable extends Component {
  connectedCallback() {
    super.connectedCallback();

    const radios = this.querySelectorAll('input[type="radio"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) {
          this.setAttribute('data-active-unit', radio.value);
        }
      });
    });

    // Initialize with the currently checked radio's value if present
    const checkedRadio = this.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      this.setAttribute('data-active-unit', checkedRadio.value);
    }
  }
}

if (!customElements.get('measurement-table')) {
  customElements.define('measurement-table', MeasurementTable);
}
